import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { CompleteTranslationFieldsFragmentDoc } from '@/experiences/sales-portal/blocs/documents/sales-portal-translation-fragments.generated';
import { gql } from '@apollo/client';
import { SalesPortalOrderEntryTable_OrderEntryItemFieldsFragmentDoc } from './sales-portal-order-entry-item-fields.generated';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const OrderEntryDataDocument = gql`
  query OrderEntryData(
    $supplierUUID: uuid!
    $restaurantUUID: uuid!
    $deliveryDate: String
    $limit: Int
    $orderGuideItemFilter: OrderEntryOrderGuideItemFilter
    $locale: String
  ) {
    cart: getOrderEntryItemsFromCart(
      supplier_id: $supplierUUID
      restaurant_id: $restaurantUUID
      delivery_date: $deliveryDate
    ) {
      order_entry_items {
        ...SalesPortalOrderEntryTable_OrderEntryItemFields
      }
    }
    orderGuide: getOrderEntryItemsFromOrderGuide(
      supplier_id: $supplierUUID
      restaurant_id: $restaurantUUID
      delivery_date: $deliveryDate
      limit: $limit
      order_guide_item_filter: $orderGuideItemFilter
      locale: $locale
    ) {
      price_edit_display_headers {
        key
        is_confidential
        category
        translation {
          ...CompleteTranslationFields
        }
      }
      order_entry_items {
        ...SalesPortalOrderEntryTable_OrderEntryItemFields
      }
    }
  }
  ${SalesPortalOrderEntryTable_OrderEntryItemFieldsFragmentDoc}
  ${CompleteTranslationFieldsFragmentDoc}
`;
export function useOrderEntryDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.OrderEntryDataQuery,
    Types.OrderEntryDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.OrderEntryDataQuery,
    Types.OrderEntryDataQueryVariables
  >(OrderEntryDataDocument, options);
}
export function useOrderEntryDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.OrderEntryDataQuery,
    Types.OrderEntryDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.OrderEntryDataQuery,
    Types.OrderEntryDataQueryVariables
  >(OrderEntryDataDocument, options);
}
export type OrderEntryDataQueryHookResult = ReturnType<
  typeof useOrderEntryDataQuery
>;
export type OrderEntryDataLazyQueryHookResult = ReturnType<
  typeof useOrderEntryDataLazyQuery
>;
export type OrderEntryDataQueryResult = Apollo.QueryResult<
  Types.OrderEntryDataQuery,
  Types.OrderEntryDataQueryVariables
>;

/**
 * Wrapped version of useGeneratedOrderEntryDataQuery using Pepper's useWrappedQuery
 */
export function useGeneratedOrderEntryDataQuery(
  options?: Apollo.QueryHookOptions<
    Types.OrderEntryDataQuery,
    Types.OrderEntryDataQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.OrderEntryDataQuery,
    Types.OrderEntryDataQueryVariables
  >(OrderEntryDataDocument, options);
}

/**
 * Wrapped version of useGeneratedOrderEntryDataLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedOrderEntryDataLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.OrderEntryDataQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.OrderEntryDataQuery,
    Types.OrderEntryDataQueryVariables
  >(OrderEntryDataDocument, lazyOptions);
}
